import { type FC } from 'react';

import {
  useCheckPlantsCheck,
  useCheckRequirements,
} from '@/common/hooks/check-requirements';
import { type FactoryTypeText } from '@/common/types/factory';
import { useAppSelector } from '@/redux/store';

import CardFactoriesLi from './CardFactoriesLi';

const CardFactories: FC = () => {
  const workshops = useAppSelector((state) => state.workshop.list);
  const nextToBuild = useAppSelector((state) => state.workshop.nextToBuild);
  const { isComplete } = useCheckRequirements(
    nextToBuild?.creationRequirements,
  );
  const completePlants = useCheckPlantsCheck(
    nextToBuild?.creationRequirements.plants,
  );

  return (
    <ul className="flex flex-col gap-2 mt-4">
      {workshops?.map(
        ({ id, name, products, nextLevelRequirements, level }) => (
          <CardFactoriesLi
            key={id}
            id={id}
            name={name as FactoryTypeText}
            products={products.map(({ id, name }) => ({
              id,
              name,
            }))}
            nextLevelRequirements={nextLevelRequirements}
            level={level}
          />
        ),
      )}
      {nextToBuild && (
        <CardFactoriesLi
          id={nextToBuild.id}
          name={nextToBuild.name as FactoryTypeText}
          products={[]}
          isNextToBuild={true}
          isRequirenmentsComplete={isComplete}
          completePlants={completePlants}
        />
      )}
    </ul>
  );
};

export default CardFactories;
